
import React, { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '@/components/NavBar';
import Footer from '@/components/MainFooter';
import { HeroSection } from '@/components/hire-with-ai/HeroSection';
import { CompanyLogos } from '@/components/hire-with-ai/CompanyLogos';
import { ComparisonSection } from '@/components/hire-with-ai/ComparisonSection';
import { FAQSection } from '@/components/hire-with-ai/FAQSection';
import { CTASection } from '@/components/hire-with-ai/CTASection';

const HireWithAI = () => {
  const heroRef = useRef<HTMLDivElement>(null);
  const problemsRef = useRef<HTMLDivElement>(null);
  const comparisonRef = useRef<HTMLDivElement>(null);
  const faqRef = useRef<HTMLDivElement>(null);
  const ctaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const refs = [heroRef, problemsRef, comparisonRef, faqRef, ctaRef];
    
    refs.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      refs.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Find hires without losing hours | Cutshort</title>
        <meta name="description" content="Cutshort combines India's largest premium tech talent pool with the technology to help you make offers in as soon as 48 hours and with 80% less effort." />
        
        <meta property="og:title" content="Find hires without losing hours | Cutshort" />
        <meta property="og:description" content="Cutshort combines India's largest premium tech talent pool with the technology to help you make offers in as soon as 48 hours and with 80% less effort." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://cutshort.io/hire-with-ai" />
        <meta property="og:image" content="/lovable-uploads/de5c00a4-0171-4728-baaf-80ada2d8d3fd.png" />
        <meta property="og:site_name" content="Cutshort" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Find hires without losing hours | Cutshort" />
        <meta name="twitter:description" content="Cutshort combines India's largest premium tech talent pool with the technology to help you make offers in as soon as 48 hours and with 80% less effort." />
        <meta name="twitter:image" content="/lovable-uploads/de5c00a4-0171-4728-baaf-80ada2d8d3fd.png" />
        <meta name="twitter:site" content="@Cutshort_io" />
        
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://cutshort.io/hire-with-ai" />
      </Helmet>

      <NavBar />
      
      <div ref={heroRef} className="opacity-0 translate-y-4 transition-all duration-1000">
        <HeroSection />
        <CompanyLogos />
      </div>
      
      <div ref={comparisonRef} className="opacity-0 translate-y-4 transition-all duration-1000">
        <ComparisonSection />
      </div>
      
      <div ref={faqRef} className="opacity-0 translate-y-4 transition-all duration-1000">
        <FAQSection />
      </div>
      
      <div ref={ctaRef} className="opacity-0 translate-y-4 transition-all duration-1000">
        <CTASection />
      </div>
      
      <Footer />
    </div>
  );
};

export default HireWithAI;
